export default __webpack_public_path__ + "static/media/pr_c_07.228fad87.jpg";